module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-card"
  }, [_vm._m(0), _c('div', {
    ref: "employeesScroll",
    staticClass: "employees-scroll",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [(_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "initial-loading"
  }, [_c('span', {
    staticClass: "loader"
  }), _c('span', [_vm._v("Cargando empleados...")])]) : (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._m(1), _vm._m(2)]) : [_vm._l((_vm.lista), function(empleado, index) {
    return _c('div', {
      key: empleado.id || empleado.numeroDocumento || index,
      staticClass: "employee"
    }, [_c('div', {
      staticClass: "employee-avatar"
    }, [_vm._v(_vm._s(empleado.usuario))]), _c('div', {
      staticClass: "employee-info"
    }, [_c('strong', [_vm._v(_vm._s(empleado.nombre))]), _c('span', {
      staticClass: "employee-position"
    }, [_vm._v(_vm._s(empleado.cargo || 'Sin cargo registrado'))]), _c('span', {
      staticClass: "employee-area"
    }, [_vm._v(_vm._s(empleado.area || 'Sin área registrada'))])]), _c('div', {
      staticClass: "employee-entry"
    }, [_c('small', [_vm._v("Fecha de ingreso")]), _c('strong', [_vm._v(_vm._s(empleado.fechaIngreso))])])])
  }), (_vm.isScroll) ? _c('div', {
    staticClass: "scroll-loading"
  }, [_c('span', {
    staticClass: "loader loader-small"
  }), _c('span', [_vm._v("Cargando más empleados...")])]) : _vm._e(), (_vm.noMore && _vm.lista.length > 0) ? _c('div', {
    staticClass: "scroll-end"
  }, [_c('span', [_vm._v("No hay más empleados nuevos")])]) : _vm._e()]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h2', [_vm._v("Nuevos empleados")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-info"
  }, [_c('strong', [_vm._v("No hay empleados nuevos")]), _c('span', [_vm._v("No se encontraron nuevas incorporaciones.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a6b6367","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_nuevos_empleados.vue
// module id = 846
// module chunks = 0